import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadingStrategy } from '@angular/router';
import { AuthGuard } from '../app/_guard/auth.guard';
import { OnboardingGuard } from '../app/_guard/onboarding.guard';


import { SigninComponent } from './Auth/signin/signin.component';
import { SignupComponent } from './Auth/signup/signup.component';
import { ForgotpasswordComponent } from './Auth/forgotpassword/forgotpassword.component';
import { ChangepasswordComponent } from './Auth/changepassword/changepassword.component';
import { DashboardComponent } from './Pages/dashboard/dashboard.component';
import { SinglesComponent } from './Pages/singles/singles.component';
import { SearchComponent } from './Pages/search/search.component';
import { FaqComponent } from './Pages/faq/faq.component';
import { ProfileComponent } from './Pages/profile/profile.component';
import { PurchaseComponent } from './Pages/purchase/purchase.component';
import { PartnersComponent } from './Pages/partners/partners.component';
import { AlbumsComponent } from './Pages/albums/albums.component';
import { CreatealbumsComponent } from './Pages/createalbums/createalbums.component';
import { CreatesinglevideopostComponent } from './Pages/createsinglevideopost/createsinglevideopost.component';
import { CreateprogramComponent } from './Pages/createprogram/createprogram.component';
import { FollowersComponent } from './Pages/followers/followers.component';
import { FinancialsComponent } from './Pages/financials/financials.component';
import { VideodetailComponent } from './Pages/videodetail/videodetail.component';
import { AlbumslistComponent } from './Pages/albumslist/albumslist.component';
import { BankdetailComponent } from './Pages/bankdetail/bankdetail.component';
import { BankAccountSetupComponent } from './Pages/profile/bank-account-setup/bank-account-setup.component';
import { EditsinglevideopostComponent } from './Pages/editsinglevideopost/editsinglevideopost.component';
import { ProgramsComponent } from './Pages/programs/programs.component';
import { EditProfileComponent } from './Pages/profile/edit-profile/edit-profile.component';
import { VerifymailComponent } from './Auth/verifymail/verifymail.component';
import { VideoUploadComponent } from './Pages/video-upload/video-upload.component';
import { CollebrationDetailComponent } from './Pages/collebration-detail/collebration-detail.component';
import { DemoDashboardComponent } from './Pages/demo-dashboard/demo-dashboard.component';
import { CreatePostComponent } from './Pages/create-post/create-post.component';
import { StaticPageComponent } from './Auth/static-page/static-page.component';
import { PrivacyPolicyComponent } from './Pages/privacy-policy/privacy-policy.component';
import { DeleteAccountComponent } from './Pages/delete-account/delete-account.component';


const routes: Routes = [
  {path:'',component:SigninComponent ,canActivate: [AuthGuard] },
  {path:'signin',component:SigninComponent ,canActivate: [AuthGuard] },
  {path:'signup',component:SignupComponent ,canActivate: [AuthGuard] },
  {path:'forgot-password',component:ForgotpasswordComponent ,canActivate: [AuthGuard] },
  {path:'reset-password/:token',component:ForgotpasswordComponent ,canActivate: [AuthGuard] },
  {path:'verify-email/:token',component:VerifymailComponent ,canActivate: [AuthGuard] }, 
  {path:'confirmation-account-verification/:token',component:VerifymailComponent ,canActivate: [AuthGuard] }, 
  {path:'success-account-verification/:token',component:VerifymailComponent ,canActivate: [AuthGuard] }, 
  {path:'failed-account-verification/:token',component:VerifymailComponent ,canActivate: [AuthGuard] }, 
  {path:'verify-email-mobile/:token',component:VerifymailComponent ,canActivate: [AuthGuard] }, 
  {path:'change-password',component:ChangepasswordComponent ,canActivate: [AuthGuard] },
  {path:'demo-dashboard',component:DashboardComponent ,canActivate: [AuthGuard] },
  {path:'dashboard',component:DemoDashboardComponent ,canActivate: [AuthGuard] },
  {path:'singles',component:SinglesComponent ,canActivate: [AuthGuard] },
  {path:'search',component:SearchComponent ,canActivate: [AuthGuard]  },
  {path:'faq',component:FaqComponent },
  {path:'profile',component:ProfileComponent ,canActivate: [AuthGuard] },
  {path:'edit-profile',component:EditProfileComponent ,canActivate: [AuthGuard] },
  {path:'editprofile',component:EditProfileComponent ,canActivate: [AuthGuard] },
  {path:'presentation',component:EditProfileComponent ,canActivate: [AuthGuard, OnboardingGuard], data: { requireOnboarding: 'subscription' } },

  {path:'purchase',component:PurchaseComponent ,canActivate: [AuthGuard] },
  {path:'partners',component:PartnersComponent ,canActivate: [AuthGuard] },
  {path:'albums',component:AlbumsComponent ,canActivate: [AuthGuard]  },
  {path:'programs',component:ProgramsComponent ,canActivate: [AuthGuard]  },
  {path:'create-albums',component:CreatealbumsComponent ,canActivate: [AuthGuard, OnboardingGuard], data: { requireOnboarding: 'content' } },
  {path:'edit-albums',component:CreatealbumsComponent ,canActivate: [AuthGuard, OnboardingGuard], data: { requireOnboarding: 'content' } },
  {path:'create-post',component:CreatesinglevideopostComponent ,canActivate: [AuthGuard, OnboardingGuard], data: { requireOnboarding: 'content' }  },
  {path:'update-post',component:CreatesinglevideopostComponent ,canActivate: [AuthGuard, OnboardingGuard], data: { requireOnboarding: 'content' }  },

  {path:'image-cropper',component:CreatePostComponent ,canActivate: [AuthGuard, OnboardingGuard], data: { requireOnboarding: 'content' }  },
  // {path:'update-post',component:CreatePostComponent ,canActivate: [AuthGuard]  },

  {path:'create-posts',component:VideoUploadComponent ,canActivate: [AuthGuard, OnboardingGuard], data: { requireOnboarding: 'content' }  },
  {path:'update-posts',component:VideoUploadComponent ,canActivate: [AuthGuard, OnboardingGuard], data: { requireOnboarding: 'content' }  },

  {path:'edit-single-post',component:EditsinglevideopostComponent ,canActivate: [AuthGuard, OnboardingGuard], data: { requireOnboarding: 'content' }  },
  {path:'create-program',component:CreateprogramComponent ,canActivate: [AuthGuard, OnboardingGuard], data: { requireOnboarding: 'content' }  },
  {path:'edit-program',component:CreateprogramComponent ,canActivate: [AuthGuard, OnboardingGuard], data: { requireOnboarding: 'content' }  },
  {path:'followers',component:FollowersComponent ,canActivate: [AuthGuard]  },
  {path:'financials',component:FinancialsComponent ,canActivate: [AuthGuard]  },
  {path:'video-detail',component:VideodetailComponent ,canActivate: [AuthGuard] },
  {path:'album-video-list',component:AlbumslistComponent ,canActivate: [AuthGuard] },
  {path:'program-video-list',component:AlbumslistComponent ,canActivate: [AuthGuard] },
  {path:'add-bank-detail',component:BankdetailComponent ,canActivate: [AuthGuard, OnboardingGuard], data: { requireOnboarding: 'bank' } },
  {path:'edit-bank-detail',component:BankdetailComponent ,canActivate: [AuthGuard, OnboardingGuard], data: { requireOnboarding: 'bank' } },
  {path:'bank-detail',component:BankdetailComponent ,canActivate: [AuthGuard, OnboardingGuard], data: { requireOnboarding: 'bank' } },
  {path:'bank-account-setup',component:BankAccountSetupComponent ,canActivate: [AuthGuard, OnboardingGuard], data: { requireOnboarding: 'bank' } },
  {path:'bank-account',component:BankAccountSetupComponent ,canActivate: [AuthGuard, OnboardingGuard], data: { requireOnboarding: 'bank' } },
  {path:'share-detail',component:CollebrationDetailComponent ,canActivate: [AuthGuard] },
  {path:'privacy-policy',component:StaticPageComponent },
  {path:'terms-conditions',component:StaticPageComponent },
  {path:'termsandconditions',component:StaticPageComponent },

   { path:'privacy-policy',component:PrivacyPolicyComponent },
  { path:'about-us',component:PrivacyPolicyComponent },
  { path:'term-condition',component:PrivacyPolicyComponent },
  { path:'delete-account',component:DeleteAccountComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes,
    //    {
    // preloadingStrategy: PreloadingStrategy }
    )
],
  exports: [RouterModule]
})
export class AppRoutingModule { }
